import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";

export default function AgencyDemandSignals() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/agency/demand-signals").then(r => setItems(r.data)).catch(() => {}); }, []);

  const sorted = [...items].sort((a, b) => (b.request_count || 0) - (a.request_count || 0));

  return (
    <AdminLayout>
      <div className="haruki-fade-in">
        <h1 className="font-heading text-3xl font-bold">Demand Signals</h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Cross-agency demand for scenarios. Threshold (50 requests, 5 agencies, no library match) triggers production queue automatically.
          Elevated priority: HMDE fire rate ≥ 40% with 20+ requests across 3+ agencies.
        </p>

        <Card className="mt-8">
          <CardContent className="p-0">
            <table className="w-full text-sm">
              <thead className="border-b border-border text-left text-xs uppercase tracking-widest text-muted-foreground">
                <tr>
                  <th className="px-4 py-3">Vertical</th>
                  <th className="px-4 py-3">Incident / Beat</th>
                  <th className="px-4 py-3">Modality</th>
                  <th className="px-4 py-3 text-right">Requests</th>
                  <th className="px-4 py-3 text-right">Agencies</th>
                  <th className="px-4 py-3 text-right">Fire rate</th>
                </tr>
              </thead>
              <tbody>
                {sorted.map(d => (
                  <tr key={d.demand_id} data-testid={`demand-row-${d.demand_id}`} className="border-b border-border last:border-0">
                    <td className="px-4 py-3">{d.vertical?.replace(/_/g, " ")}</td>
                    <td className="px-4 py-3">{d.incident_category?.replace(/_/g, " ")} / {d.emotional_beat?.replace(/_/g, " ")}</td>
                    <td className="px-4 py-3">{d.modality_primary?.replace(/_/g, " ")}</td>
                    <td className="px-4 py-3 text-right font-medium">{d.request_count}</td>
                    <td className="px-4 py-3 text-right">{d.agency_count}</td>
                    <td className="px-4 py-3 text-right">{Math.round((d.avg_hmde_fire_rate || 0) * 100)}%</td>
                  </tr>
                ))}
                {sorted.length === 0 && (
                  <tr><td colSpan="6" className="px-4 py-6 text-center text-sm text-muted-foreground">No demand signals yet — they accumulate as members complete scenarios.</td></tr>
                )}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
}
